import { useContext } from "react";
import { PhoneContext } from "./PhoneContext";

export const usePhone = () => {
  const context = useContext(PhoneContext);

  if (!context) {
    throw new Error("usePhone must be used inside PhoneProvider.");
  }

  return context;
};
